export default __webpack_public_path__ + "static/media/no_image.fb289eda.png";